/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class TitlecaseFilter {
    public static filter(): any {
        return (input: string): string => {
            if (!angular.isString(input) || input.length == 0) {
                return input;
            }
            return input
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.substr(1))
                .join(' ');
        };
    }
}


angular.module('beneple.global')
    .filter('titlecase', TitlecaseFilter.filter);



// WEBPACK FOOTER //
// ./frontend/scripts/global/filters/titlecase.filter.ts